import React, { useState } from "react";
import EtTable from "./component/EtTable";
import Header from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import SoldPhones from "./component/SoldPhones";
import Unpaid from "./component/Unpaid";
import DailyUpdate from "./component/DailyUpdate";
import DailyRate from "./component/DailyRate";
import FinanceTable from "./component/FinanceTable";
import People from "./component/People";
import Repair from "./component/Repair";
import Overall from "../../component/Example";
import ShippedTo from "./component/ShippedTo";
import AdamaTable from "../Adama/AdamaTable";
import ProductsTable from "./component/ProductsTable";

function Summary() {
  const [rate, setRate] = useState(0);
  const [data, setData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("EtTable");

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${apiUrl}/dailyRate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ rate }),
      });
      if (!response.ok) throw new Error("Network response was not ok");
      setRate(0);
    } catch (error) {
      console.error("Error:", error);
    }
  };

 

  const latestRate = data.length > 0 ? data[data.length - 1].rate : null;

  const tabs = [
    { key: "EtTable", label: "Available" },
    { key: "Unpaid", label: "Unpaid" },
    { key: "Adama", label: "Adama" },
    { key: "DailyUpdate", label: "Daily Update" },
    { key: "Rate", label: "Daily Rate" },
    { key: "Repair", label: "Repair" },
    { key: "People", label: "Commissions" },
    { key: "FinanceTable", label: "Finance" },
    { key: "Overall", label: "Overall" },
    { key: "SoldPhones", label: "Sold Phones" },
    { key: "ShippedTo", label: "Shipped To" },
    { key: "ProductsTable", label: "StockCheck" },
  ];

  const renderTab = () => {
    switch (selectedTab) {
      case "EtTable":
        return <EtTable />;
      case "Unpaid":
        return <Unpaid rate={latestRate} />;
      case "DailyUpdate":
        return <DailyUpdate />;
      case "Rate":
        return <DailyRate />;
      case "Repair":
        return <Repair />;
      case "People":
        return <People />;
      case "FinanceTable":
        return <FinanceTable />;
      case "Overall":
        return <Overall />;
      case "SoldPhones":
        return <SoldPhones />;
      case "ShippedTo":
        return <ShippedTo />;
      case "Adama":
        return <AdamaTable />;
      case "ProductsTable":
        return <ProductsTable />;
      default:
        return null;
    }
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Header />
      <Sidebar />
      <div className="mt-28 px-4 flex flex-col h-full">
        <div className="sticky top-28 z-10 bg-white pt-2">
          <div className="overflow-x-auto">
            <div className="flex justify-center space-x-2 min-w-max px-4">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setSelectedTab(tab.key)}
                  className={`px-4 py-2 rounded-full text-sm whitespace-nowrap ${
                    selectedTab === tab.key
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-700"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto mt-4 pb-10">{renderTab()}</div>
      </div>
    </div>
  );
}

export default Summary;
